import React from 'react';
import PropTypes from 'prop-types';
import SettingsIcon from '@material-ui/icons/Settings';
import Tooltip from '@ublend-npm/react-tooltip';
import Divider from '@material-ui/core/Divider';

import {
  CurrentSpaceContainer,
  CurrentText,
  CurrentSpaceItem,
  PrimaryTextContainer,
  SecondaryListItem,
  SecondaryText,
  SecondaryIcon,
  AvatarContainer,
} from './CurrentSpace.styled';

import AvatarUploader from '../../../common/AvatarUploader/AvatarUploader';

import SpaceProptypes from './Space.proptype';

const CurrentSpace = ({
  space,
  onAvatarClick,
  onSettingsClick,
  isLoading,
  isAdmin,
  tooltipPosition,
  avatarProps,
  avatarUploaderId,
}) => (
  <>
    <CurrentSpaceContainer data-testid="current-space">
      <CurrentText>Current space</CurrentText>
      <CurrentSpaceItem>
        <Tooltip
          title="Change image"
          position={tooltipPosition}
          enabled={isAdmin}
        >
          <AvatarContainer>
            <AvatarUploader
              inputId={avatarUploaderId}
              onUpload={onAvatarClick}
              name={space.name}
              url={space.avatar}
              size="xLarge"
              uploadEnable={isAdmin}
              isLoading={isLoading}
              {...avatarProps}
            />
          </AvatarContainer>
        </Tooltip>
        <PrimaryTextContainer>
          <span>{space.name}</span>
        </PrimaryTextContainer>
      </CurrentSpaceItem>
      <SecondaryListItem
        component="div"
        data-testid="space-settings-link"
        id="space-settings"
        onClick={onSettingsClick}
        tabIndex="0"
      >
        <SecondaryIcon
          disableRipple
          size="xSmall"
          icon={SettingsIcon}
          type="tertiary"
          label=""
          buttonAttributes={{ tabIndex: -1 }}
        />
        <SecondaryText>Space settings</SecondaryText>
      </SecondaryListItem>
    </CurrentSpaceContainer>
    <Divider />
  </>
);

CurrentSpace.propTypes = {
  space: PropTypes.shape(SpaceProptypes).isRequired,
  onAvatarClick: PropTypes.func,
  onSettingsClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isAdmin: PropTypes.bool,
  tooltipPosition: PropTypes.string,
  avatarProps: PropTypes.shape({}),
  avatarUploaderId: PropTypes.string.isRequired,
};

CurrentSpace.defaultProps = {
  onAvatarClick: () => {},
  isLoading: false,
  isAdmin: false,
  tooltipPosition: 'bottom',
  avatarProps: {},
};

export default CurrentSpace;
